import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import clsx from "clsx";
import "./ProgNav.css";

const ProgNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.split("/");
  const current = location.pathname.toLowerCase();

  const programId = path[1] === "programs" ? path[2] : undefined;
  const baseTo = programId ? `/programs/${programId}` : "/programs";

  const links = [
    { name: "About", href: baseTo + "/about", value: "about" },
    { name: "Admissions", href: baseTo + "/admissions", value: "admissions" },
    { name: "Research", href: baseTo + "/research", value: "research" },
    { name: "People", href: baseTo + "/people", value: "people" },
    { name: "Curriculum", href: baseTo + "/resources", value: "resources" },
  ];

  // Find current active link
  const activeLink = links.find((link) =>
    current.startsWith(link.href.toLowerCase())
  ) || links[0];

  // Handle dropdown change
  const handleDropdownChange = (e) => {
    const selectedValue = e.target.value;
    const selectedLink = links.find((link) => link.value === selectedValue);
    if (selectedLink) {
      navigate(selectedLink.href);
    }
  };

  return (
    <nav className="prog-nav" aria-label="Program sections">
      <div className="prog-nav-brand-wrap">
        <Link to={baseTo} className="prog-nav-brand">
          Program
        </Link>
      </div>
      <div className="prog-nav-desktop">
        {links.map((link) => {
          const isActive = current.startsWith(link.href.toLowerCase());
          return (
            <Link
              key={link.name}
              to={link.href}
              className={clsx(
                "prog-nav-link",
                isActive && "is-active"
              )}
            >
              {link.name}
            </Link>
          );
        })}
      </div>
      {/* Mobile: Dropdown */}
      <div className="prog-nav-mobile">
        <select
          value={activeLink.value}
          onChange={handleDropdownChange}
          className="prog-nav-dropdown"
          aria-label="Select program section"
        >
          {links.map((link) => (
            <option key={link.value} value={link.value}>
              {link.name}
            </option>
          ))}
        </select>
      </div>
    </nav>
  );
};

export default ProgNav;
